export const accountingPath = () => "/accounting";
export const accountingCostsPath = () => "/accounting/costs";
export const accountingCheckoutSuccessPath = () => "/accounting/checkout/success";
export const accountingCheckoutCancelPath = () => "/accounting/checkout/cancel";
